import { useState, useRef } from "react";
import { ReplyFill } from "react-bootstrap-icons";
import { ChatMessageWrapperProps } from "./message-item-wrapper.props";

export const ChatMessageWrapper = ({
  msg,
  idx,
  onReply,
  children,
  isUserMsg,
  messageRefs,
  isFirstUnread,
  highlightedMessageId,
  isRapidClicking,
  modeSelected,
  onSelectMessage,
  onMouseDown,
  onMouseEnter,
  onMouseUp,
}: ChatMessageWrapperProps) => {
  const [dragX, setDragX] = useState(0);
  const [replyActive, setReplyActive] = useState(false);
  const startXRef = useRef(0);
  const startYRef = useRef(0);
  const draggingRef = useRef(false);
  const isHorizontalDrag = useRef(false);

  const MAX_LEFT = 50;
  const THRESHOLD = 35;
  const HORIZONTAL_SWIPE_ANGLE = 10;

  const handleTouchStart = (e: React.TouchEvent) => {
    if (modeSelected) return;
    const touch = e.touches[0];
    startXRef.current = touch.clientX;
    startYRef.current = touch.clientY;
    draggingRef.current = true;
    isHorizontalDrag.current = false;
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (!draggingRef.current || modeSelected) return;
    const touch = e.touches[0];
    const deltaX = touch.clientX - startXRef.current;
    const deltaY = touch.clientY - startYRef.current;

    if (Math.abs(deltaX) > Math.abs(deltaY) + HORIZONTAL_SWIPE_ANGLE) {
      isHorizontalDrag.current = true;
      e.preventDefault();

      if (deltaX < 0) {
        const limitedX = Math.max(deltaX, -MAX_LEFT);
        setDragX(limitedX);

        if (limitedX === -MAX_LEFT && "vibrate" in navigator) {
          navigator.vibrate(10);
        }

        setReplyActive(Math.abs(limitedX) > THRESHOLD);
      } else {
        setDragX(Math.min(deltaX, 0));
        setReplyActive(false);
      }
    }
  };

  const handleTouchEnd = () => {
    if (replyActive) onReply();

    setDragX(0);
    setReplyActive(false);
    draggingRef.current = false;
    isHorizontalDrag.current = false;
  };

  return (
    <div
      key={`${msg._id}-${idx}`}
      ref={(el) => {
        messageRefs.current[msg._id] = el;
      }}
      className={`${
        highlightedMessageId === msg._id ? "message-highlighted" : ""
      } ${isRapidClicking ? "rapid" : ""}`}
      data-msg-id={msg._id}
      style={{
        transform: `translateX(${dragX}px)`,
        transition: draggingRef.current ? "none" : "transform 0.2s ease",
        position: "relative",
        touchAction: "pan-y",
      }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      onMouseUp={onMouseUp}
    >
      {isFirstUnread && (
        <div
          className="text-center text-secondary mb-2"
          style={{
            position: "relative",
            top: "-2px",
            fontSize: "12px",
            fontWeight: 500,
          }}
        >
          — Непрочитанные сообщения —
        </div>
      )}

      {replyActive && (
        <div
          style={{
            position: "absolute",
            bottom: 4,
            transform: "translateY(-50%)",
            right: -30,
          }}
        >
          <ReplyFill size={20} />
        </div>
      )}

      {children}
    </div>
  );
};
